import { BuildingIcon, ProfileIcon } from "../../components/AscIcons";

export const DEFAULT_DEMO_QUESTION = {
  title: "Congratulations!",
  description: "You are all set up",
  options: [
    {
      label: "Experience the product myself",
      value: false,
      icon: <ProfileIcon />,
    },
    {
      label: "Request a product demo",
      value: true,
      icon: <BuildingIcon />,
    },
  ],
};

export const DEFAULT_GOAL_QUESTION = {
  title: "Congratulations!",
  description: "Now you know what your students will get",
  options: [
    {
      label: "Experience School Admin",
      value: "EXP_SCHOOL_ADMIN",
    },
    {
      label: "Speak to a Representative",
      value: "SPEAK_TO_REPRESENTATIVE",
    },
    {
      label: "Onboard my school",
      value: "ONBOARD_SCHOOL",
    },
  ],
};

export const DEFAULT_DEMO_DATE_QUESTION = {
  title: "Choose date!",
  description: "Pick 2 time slots for demo",
};

export const DEFAULT_IN_TOUCH_PROMPT = {
  title: "Always in touch!",
  description: "Be on the look out for an email from our team",
};
